import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-action-link',
  templateUrl: './action-link.component.html',
  styleUrls: ['./action-link.component.scss']
})
export class ActionLinkComponent implements OnInit {

  @Input() href: string;
  @Input() target: string;

  constructor() {

  }

  ngOnInit() {
  }

}

@NgModule({
  declarations: [ActionLinkComponent],
  imports: [
    CommonModule,
    LinkModule,
  ],
  exports: [ActionLinkComponent]
})
export class ActionLinkModule { }
